import { useMemo, useState } from 'react';
import { InlineAutocompleteWithExternalTrigger } from '../../input/InlineAutoComplete/InlineAutocompleteWithExternalTrigger';
import { ExternalDropdownTrigger } from '../../shared/components/ExternalDropdownTrigger/ExternalDropdownTrigger';
import { getDataIdGenerator } from '../../shared/utils/dataId';
import { SortList } from '../list-actions';
import { ListConductor } from '../list-conductor';
import { SortDirection } from '../sort';
import { SortDropdownOption } from './interface';

const dataIdGenerator = getDataIdGenerator('');

export function SortDropdown({
  className,
  listConductor,
  sortOptions
}: {
  className?: string;
  sortOptions: SortDropdownOption[];
  listConductor: ListConductor;
}) {
  const [open, setOpen] = useState(false);

  const dropdownOptions = useMemo(() => {
    return sortOptions.map(option => ({
      LabelComponent: typeof option.label === 'string' ? undefined : option.label,
      label: typeof option.label === 'string' ? option.label : undefined,
      key: option.key,
      direction: option.direction
    }));
  }, [sortOptions]);

  const listConductorSortData = listConductor.getListMeta().sort;

  const sortValue = useMemo(() => {
    if (!listConductorSortData || Object.keys(listConductorSortData).length === 0) {
      return null;
    }

    return dropdownOptions.find(o => {
      const [key, direction] = Object.entries(listConductor.getListMeta().sort)[0];
      return o.key === key && o.direction === direction;
    });
  }, [dropdownOptions, listConductorSortData]);

  const CurrentValueLabelComponent = sortValue?.LabelComponent;

  return (
    <>
      <ExternalDropdownTrigger
        id={dataIdGenerator('dropdown')}
        thumbnail='sort'
        className={className}
        onClick={() => setOpen(o => !o)}
        thumbnailStyles={
          sortValue?.direction === SortDirection.DESC ? { transform: 'rotate(-180deg)' } : {}
        }
      >
        {CurrentValueLabelComponent ? <CurrentValueLabelComponent /> : sortValue?.label}
      </ExternalDropdownTrigger>

      <InlineAutocompleteWithExternalTrigger
        value={sortValue}
        close={() => setOpen(false)}
        target={`#${dataIdGenerator('dropdown')}`}
        dataId={dataIdGenerator('dropdown')}
        open={open}
        options={dropdownOptions}
        selectMode
        onChange={v => {
          const value = v as SortDropdownOption;

          listConductor.dispatch(new SortList({ key: value.key, order: value.direction }));
        }}
        getOptionLabel={() => ''}
      />
    </>
  );
}
